import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    transform: translateY(-100%);
  }
  12.5% {
    transform: translateY(0);
  }
  92.5% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
`;

export const SuccessBanner = styled.div`
  position: absolute;
  ${props => props.theme.mediaQueries.smallDown} {
    top: -${props => props.theme.space.s6};
  }
  left: 0;
  width: 100%;
  background-color: ${props => props.theme.colors.capsuleGreen80};
  color: white;
  text-align: center;
  padding: ${props => props.theme.space.s4} 0;
  z-index: ${props => props.theme.zIndex.z3};
  animation: ${fadeIn} 4s ease-out forwards;
  svg {
    fill: white;
    margin-right: ${props => props.theme.space.s2};
  }
  i {
    line-height: 0;
  }
  display: flex;
  justify-content: center;
`;
